import { render, staticRenderFns } from "./MemberGroupSelect.vue?vue&type=template&id=53e93567&"
import script from "./MemberGroupSelect.vue?vue&type=script&lang=ts&"
export * from "./MemberGroupSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports